// extracted by mini-css-extract-plugin
export default {"container":"XVK9AOuZ"};